<template>
  <div v-if="loadingPermissions" class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100 d-flex justify-content-center align-items-center py-5">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>
  <div v-else-if="permissionError" class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100">
    <div class="alert alert-warning mx-3 mt-3">
      <p>Error al cargar menú: {{ permissionError }}</p>
      <button class="btn btn-sm btn-warning mt-2" @click="fetchUserPermissions">
        Reintentar
      </button>
    </div>
  </div>
  <div v-else class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="mt-3 nav-item">
        <div class="section-header">
          <div class="section-icon">
            <i class="ri-apps-2-line"></i>
          </div>
          <h6
            class="section-title"
            :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
          >
            MÓDULOS
          </h6>
        </div>
      </li>
      
      <!-- Página de Bienvenida - siempre visible para usuarios autenticados -->
      <li class="nav-item">
        <sidenav-collapse navText="Bienvenida" :to="{ name: 'Welcome' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <home-icon class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <!-- Panel principal accesible si tienen el permiso -->
      <li class="nav-item" v-if="hasModuleAccess('dashboard')">
        <sidenav-collapse navText="Panel" :to="{ name: 'Dashboard' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <shop class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <!-- Nuevo módulo de Actualización Masiva -->
      <li class="nav-item" v-if="hasModuleAccess('bulk_update')">
        <sidenav-collapse navText="Actualización Masiva" :to="{ name: 'ActualizacionMasiva' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <bulk-update-icon class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <!-- Elementos con control de acceso por módulos -->
      <li class="nav-item" v-if="hasModuleAccess('bulk_loads')">
        <sidenav-collapse navText="Cargas Másivas" :to="{ name: 'Billing' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <credit-card class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <li class="nav-item" v-if="hasModuleAccess('celsig5')">
        <sidenav-collapse navText="CelSig5 y SCeGR" :to="{ name: 'CelSig5' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <settings-icon class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <li class="nav-item" v-if="hasModuleAccess('connectivity')">
        <sidenav-collapse navText="CON - Conectividad" :to="{ name: 'Conectividad' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <connection-icon class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <li class="nav-item" v-if="hasModuleAccess('locations')">
        <sidenav-collapse navText="Localizaciones Celsig" :to="{ name: 'Localizaciones' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <customer-support class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <li class="nav-item" v-if="hasModuleAccess('delete_records')">
        <sidenav-collapse navText="Borrado Registros" :to="{ name: 'BorradoRegistros' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <trash-icon class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <!-- Sección de administración -->
      <li class="mt-3 nav-item" v-if="hasModuleAccess('activity') || hasModuleAccess('users') || hasModuleAccess('admin')">
        <div class="section-header">
          <div class="section-icon">
            <i class="ri-settings-3-line"></i>
          </div>
          <h6
            class="section-title"
            :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
          >
            ADMIN
          </h6>
        </div>
      </li>
      
      <!-- Nuevo módulo de Cargar Export -->
      <li class="nav-item" v-if="hasModuleAccess('cargar_export')">
        <sidenav-collapse navText="Cargar Export" :to="{ name: 'CargarExport' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <upload-icon class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <!-- Nuevo módulo de Actividad -->
      <li class="nav-item" v-if="hasModuleAccess('activity')">
        <sidenav-collapse navText="Actividad" :to="{ name: 'Activity' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <activity-icon class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <li class="nav-item" v-if="hasModuleAccess('users')">
        <sidenav-collapse navText="Usuarios" :to="{ name: 'Users' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <switches class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <li class="nav-item" v-if="hasModuleAccess('admin')">
        <sidenav-collapse navText="Admin" :to="{ name: 'Tables' }">
          <template #icon>
            <div class="sidenav-icon-wrapper">
              <office class="sidenav-icon" />
            </div>
          </template>
        </sidenav-collapse>
      </li>
      
      <!-- Separador - Solo mostrar si hay módulos de configuración disponibles -->
      <li class="mt-3 nav-item" v-if="hasConfigurationModules">
        <div class="section-header">
          <div class="section-icon">
            <i class="ri-settings-2-line"></i>
          </div>
          <h6
            class="section-title"
            :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
          >
            CONFIGURACIÓN
          </h6>
        </div>
      </li>
      
    </ul>
  </div>
</template>

<script>
import axios from "axios";
import SidenavCollapse from "./SidenavCollapse.vue";
import Shop from "../../components/Icon/Shop.vue";
import Office from "../../components/Icon/Office.vue";
import CreditCard from "../../components/Icon/CreditCard.vue";
import CustomerSupport from "../../components/Icon/CustomerSupport.vue";
import Switches from "../../components/Icon/Switches.vue";
import TrashIcon from "../../components/Icon/TrashIcon.vue";
import SettingsIcon from "../../components/Icon/SettingsIcon.vue";
import ConnectionIcon from "../../components/Icon/ConnectionIcon.vue";
import BulkUpdateIcon from "../../components/Icon/BulkUpdateIcon.vue";
import ActivityIcon from "../../components/Icon/ActivityIcon.vue";
import UploadIcon from "../../components/Icon/UploadIcon.vue";
import HomeIcon from "../../components/Icon/HomeIcon.vue";  
import { useDarkModeSafe } from "@/composables/useDarkModeSafe"; // Rehabilitado con versión optimizada

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "4CONNECT",
      controls: "dashboardsExamples",
      isActive: "active",
      userPermissions: {},
      loadingPermissions: true,
      permissionError: null,
      fetchAttempts: 0,
      maxFetchAttempts: 3
    };
  },
  components: {
    SidenavCollapse,
    Shop,
    Office,
    CreditCard,
    CustomerSupport,
    Switches,
    TrashIcon,
    SettingsIcon,
    ConnectionIcon,
    BulkUpdateIcon,
    ActivityIcon,
    UploadIcon,
    HomeIcon,
  },
  setup() {
    const { isDark } = useDarkModeSafe(); // Rehabilitado con versión optimizada
    return { 
      isDark // Rehabilitado con versión optimizada
    };
  },
  computed: {
    // Usar permisos del store para reflejar cambios en tiempo real
    currentPermissions() {
      return this.$store.getters['auth/user']?.permissions || this.userPermissions || {};
    },
    
    // Verificar si el usuario está logueado
    isUserLoggedIn() {
      return this.$store.getters['auth/loggedIn'];
    },
    
    // Clase dinámica para el tema
    themeClass() {
      return this.isDark ? 'dark-theme' : 'light-theme';
    },
    
    // Verificar si hay módulos de configuración disponibles
    hasConfigurationModules() {
      // Lista de módulos que se consideran de configuración
      const configModules = ['settings', 'preferences', 'config', 'system_config'];
      
      // Verificar si el usuario tiene acceso a algún módulo de configuración
      return configModules.some(module => this.hasModuleAccess(module));
    }
  },
  watch: {
    // Observar cambios en el estado de login
    isUserLoggedIn: {
      handler(isLoggedIn) {
        if (isLoggedIn) {
          console.log('Usuario logueado, intentando obtener permisos');
          this.fetchUserPermissionsWithDelay();
        } else {
          console.log('Usuario no logueado, limpiando permisos');
          this.userPermissions = {};
          this.loadingPermissions = false;
        }
      },
      immediate: true
    },
    
    // Observar cambios en los permisos del store
    '$store.getters["auth/user"].permissions': {
      handler(newPermissions) {
        if (newPermissions && Object.keys(newPermissions).length > 0) {
          console.log('Permisos actualizados en el store:', newPermissions);
          this.userPermissions = newPermissions;
          this.loadingPermissions = false;
          this.permissionError = null;
        }
      },
      deep: true
    },
    
    // Recargar permisos cuando la ruta cambia, pero solo si el usuario está logueado
    '$route': {
      handler() {
        if (this.isUserLoggedIn && 
            (!this.currentPermissions || Object.keys(this.currentPermissions).length === 0)) {
          console.log("Recargando permisos al cambiar de ruta");
          this.fetchUserPermissionsWithDelay();
        }
      }
    }
  },
  mounted() {
    // Solo intentar obtener permisos si el usuario está logueado
    if (this.isUserLoggedIn) {
      this.fetchUserPermissionsWithDelay();
    } else {
      this.loadingPermissions = false;
    }
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    
    // Método para obtener permisos con un pequeño delay
    async fetchUserPermissionsWithDelay(delay = 300) {
      // Esperar un poco para que el token se guarde si acabamos de hacer login
      if (delay > 0) {
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      
      this.fetchUserPermissions();
    },
    
    async fetchUserPermissions() {
      // Si no estamos logueados, no intentar obtener permisos
      if (!this.isUserLoggedIn) {
        console.log('Usuario no logueado, no obteniendo permisos');
        this.loadingPermissions = false;
        return;
      }
      
      // Limitar el número de intentos
      if (this.fetchAttempts >= this.maxFetchAttempts) {
        console.warn('Máximo número de intentos alcanzado para obtener permisos');
        this.permissionError = "Error al conectar con el servidor";
        this.loadingPermissions = false;
        return;
      }
      
      try {
        this.loadingPermissions = true;
        this.permissionError = null;
        this.fetchAttempts++;
        
        console.log(`Intento ${this.fetchAttempts} de obtener permisos`);
        
        // Verificar si tenemos acceso a los permisos desde el store
        const storePermissions = this.$store.getters['auth/user']?.permissions;
        if (storePermissions && Object.keys(storePermissions).length > 0) {
          console.log("Obteniendo permisos del store:", storePermissions);
          this.userPermissions = storePermissions;
          this.loadingPermissions = false;
          this.fetchAttempts = 0; // Reset attempts on success
          return;
        }
        
        // Obtener el token de auth_token en localStorage
        const tokenJWT = localStorage.getItem('auth_token');
        
        if (!tokenJWT) {
          console.log("No se encontró token JWT en localStorage");
          
          // Si estamos logueados pero no hay token, esperar un poco y reintentar una vez
          if (this.fetchAttempts === 1) {
            this.loadingPermissions = false;
            console.log("Esperando token, reintentando en 1 segundo...");
            setTimeout(() => this.fetchUserPermissions(), 1000);
            return;
          }
          
          this.permissionError = "No hay sesión activa";
          this.userPermissions = {};
          this.loadingPermissions = false;
          
          // Limpiar el estado de autenticación si no hay token
          this.$store.commit('auth/logMeOut');
          
          return;
        }
        
        console.log("Token JWT encontrado, realizando petición a /me/permissions");
        
        const apiUrl = process.env.VUE_APP_API_BASE_URL || 'http://teleconnect.test/api/v2';
        
        const permissionsResponse = await axios.get(`${apiUrl}/me/permissions`, {
          headers: {
            'Authorization': `Bearer ${tokenJWT}`,
            'Accept': 'application/json'
          }
        });
        
        console.log("Respuesta de /me/permissions:", permissionsResponse.data);
        
        if (permissionsResponse.data && permissionsResponse.data.data) {
          this.userPermissions = permissionsResponse.data.data;
          console.log("Permisos obtenidos:", this.userPermissions);
          
          // Actualizar los permisos en el store
          if (this.$store.commit) {
            this.$store.commit('auth/updateUser', {
              ...this.$store.getters['auth/user'],
              permissions: this.userPermissions
            });
          }
          
          // Reset attempts on success
          this.fetchAttempts = 0;
        } else {
          console.warn("La respuesta de /me/permissions no contiene datos válidos");
          this.permissionError = "Formato de respuesta incorrecto";
          this.userPermissions = {};
        }
      } catch (error) {
        console.error("Error al obtener permisos del usuario:", error);
        this.permissionError = "Error de conexión";
        this.userPermissions = {};
        
        // Si es error 401 o 403, el token es inválido
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          console.warn("Error de autenticación, limpiando sesión");
          this.permissionError = "Sesión expirada";
          
          // Limpiar localStorage y store
          localStorage.removeItem('auth_token');
          localStorage.removeItem('userF');
          this.$store.commit('auth/logMeOut');
          
          // El guard del router manejará la redirección
          this.fetchAttempts = 0; // Reset attempts
        }
      } finally {
        this.loadingPermissions = false;
      }
    },
    
    hasModuleAccess(moduleId) {
      // Si todavía estamos cargando, no mostramos nada
      if (this.loadingPermissions) {
        return false;
      }
      
      // Si no estamos logueados, no mostrar nada
      if (!this.isUserLoggedIn) {
        return false;
      }
      
      // Usar los permisos del store para reflejar cambios en tiempo real
      const permissions = this.currentPermissions;
      
      // Verificar específicamente si tiene permiso para este módulo
      return permissions[moduleId] === true;
    }
  },
};
</script>

<style scoped>
/* Contenedor principal del sidebar con liquid glass */
.navbar-nav {
  padding: 1rem 0 0 0;
  gap: 0.25rem;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 0;
  padding-bottom: 10rem;
  background: var(--liquid-glass-bg) !important;
  backdrop-filter: blur(var(--liquid-glass-blur)) saturate(var(--liquid-glass-saturate)) brightness(var(--liquid-glass-brightness)) !important;
  -webkit-backdrop-filter: blur(var(--liquid-glass-blur)) saturate(var(--liquid-glass-saturate)) brightness(var(--liquid-glass-brightness)) !important;
  border-radius: 0 0 1rem 0;
  position: relative;
  box-shadow: var(--liquid-shadow-sm) !important;
  border-right: 1px solid var(--liquid-glass-border) !important;
}

/* Wrapper de iconos mejorado */
.sidenav-icon-wrapper {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  position: relative;
}

.sidenav-icon-wrapper svg {
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
}

/* Estilos para las cabeceras de sección con liquid glass */
.section-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  margin: 0.5rem 0.5rem 0.25rem;
  border-radius: 0.75rem;
  background: var(--liquid-glass-bg) !important;
  border: 1px solid var(--liquid-glass-border) !important;
  backdrop-filter: blur(var(--liquid-glass-blur-light)) saturate(var(--liquid-glass-saturate)) brightness(var(--liquid-glass-brightness)) !important;
  -webkit-backdrop-filter: blur(var(--liquid-glass-blur-light)) saturate(var(--liquid-glass-saturate)) brightness(var(--liquid-glass-brightness)) !important;
  position: relative;
  overflow: hidden;
  transition: var(--liquid-transition-smooth);
  box-shadow: var(--liquid-shadow-xs) !important;
}

.section-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, 
    transparent, 
    rgba(255, 255, 255, 0.6) 20%, 
    rgba(255, 255, 255, 0.8) 50%, 
    rgba(255, 255, 255, 0.6) 80%, 
    transparent
  );
  z-index: 1;
}

.section-header:hover {
  background: var(--liquid-glass-bg-hover) !important;
  border-color: var(--liquid-glass-border-hover) !important;
  box-shadow: var(--liquid-shadow-sm) !important;
  transform: translateY(-1px) scale(1.005);
  backdrop-filter: blur(var(--liquid-glass-blur)) saturate(200%) brightness(1.15) !important;
  -webkit-backdrop-filter: blur(var(--liquid-glass-blur)) saturate(200%) brightness(1.15) !important;
}

.section-icon {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background: linear-gradient(135deg, var(--dm-accent-primary, #17ad37) 0%, var(--dm-accent-secondary, #98ec2d) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.625rem;
  box-shadow: 0 4px 12px var(--dm-shadow-accent, rgba(23, 173, 55, 0.3));
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.section-icon i {
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
}

.section-header:hover .section-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 6px 16px var(--dm-shadow-accent-hover, rgba(23, 173, 55, 0.4));
}

.section-title {
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--dm-text-secondary, #6b7280);
  margin: 0;
  position: relative;
  z-index: 1;
  transition: color 0.3s ease;
}

.section-header:hover .section-title {
  color: var(--dm-accent-primary, #17ad37);
}

/* Estados de carga mejorados */
.spinner-border {
  width: 2.5rem;
  height: 2.5rem;
  color: var(--dm-accent-primary, #17ad37);
  border-width: 0.25rem;
  animation: spin 1s linear infinite, pulse-opacity 2s ease-in-out infinite;
  box-shadow: 0 0 0 2px var(--dm-bg-primary, #ffffff), 
              0 0 0 3px var(--dm-accent-primary, #17ad37);
  border-radius: 50%;
  transition: color 0.3s ease, box-shadow 0.3s ease;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse-opacity {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

/* Alert mejorado */
.alert-warning {
  background: var(--dm-bg-warning, linear-gradient(135deg, rgba(251, 191, 36, 0.1) 0%, rgba(245, 158, 11, 0.1) 100%));
  border: 1px solid var(--dm-border-warning, rgba(251, 191, 36, 0.2));
  color: var(--dm-text-warning, #92400e);
  border-radius: 0.75rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px var(--dm-shadow-warning, rgba(251, 191, 36, 0.1));
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

.alert-warning .btn {
  background: linear-gradient(135deg, var(--dm-btn-warning, #fbbf24) 0%, var(--dm-btn-warning-hover, #f59e0b) 100%);
  border: none;
  color: var(--dm-btn-warning-text, white);
  font-weight: 600;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px var(--dm-shadow-warning-btn, rgba(251, 191, 36, 0.3));
}

.alert-warning .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--dm-shadow-warning-btn-hover, rgba(251, 191, 36, 0.4));
}

/* Contenedor principal con liquid glass */
.navbar-collapse {
  background: var(--liquid-glass-bg) !important;
  backdrop-filter: blur(var(--liquid-glass-blur)) saturate(var(--liquid-glass-saturate)) brightness(var(--liquid-glass-brightness)) !important;
  -webkit-backdrop-filter: blur(var(--liquid-glass-blur)) saturate(var(--liquid-glass-saturate)) brightness(var(--liquid-glass-brightness)) !important;
  border: 1px solid var(--liquid-glass-border) !important;
  border-radius: 1rem;
  height: calc(100vh - 2rem);
  max-height: calc(100vh - 2rem);
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  box-shadow: var(--liquid-shadow-md) !important;
  position: relative;
}

/* Efectos de scroll suave */
.navbar-nav {
  scrollbar-width: thin;
  scrollbar-color: var(--dm-scrollbar-thumb, rgba(23, 173, 55, 0.3)) transparent;
}

.navbar-nav::-webkit-scrollbar {
  width: 4px;
}

.navbar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.navbar-nav::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, var(--dm-scrollbar-thumb, rgba(23, 173, 55, 0.3)), var(--dm-scrollbar-thumb-2, rgba(152, 236, 45, 0.3)));
  border-radius: 2px;
  transition: background 0.3s ease;
}

.navbar-nav::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(to bottom, var(--dm-scrollbar-thumb-hover, rgba(23, 173, 55, 0.5)), var(--dm-scrollbar-thumb-2-hover, rgba(152, 236, 45, 0.5)));
}


/* Animaciones de entrada para los elementos del menú */
.nav-item {
  animation: slideInFromLeft 0.3s ease-out;
  animation-fill-mode: both;
}

.nav-item:nth-child(1) { animation-delay: 0.1s; }
.nav-item:nth-child(2) { animation-delay: 0.15s; }
.nav-item:nth-child(3) { animation-delay: 0.2s; }
.nav-item:nth-child(4) { animation-delay: 0.25s; }
.nav-item:nth-child(5) { animation-delay: 0.3s; }
.nav-item:nth-child(6) { animation-delay: 0.35s; }
.nav-item:nth-child(7) { animation-delay: 0.4s; }
.nav-item:nth-child(8) { animation-delay: 0.45s; }
.nav-item:nth-child(9) { animation-delay: 0.5s; }
.nav-item:nth-child(n+10) { animation-delay: 0.55s; }

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive design */
@media (max-width: 1200px) {
  .section-header {
    padding: 0.5rem 0.75rem;
    margin: 0.375rem 0.375rem 0.125rem;
  }
  
  .section-icon {
    width: 1.375rem;
    height: 1.375rem;
    margin-right: 0.5625rem;
  }
  
  .section-icon i {
    font-size: 0.6875rem;
  }
  
  .section-title {
    font-size: 0.625rem;
  }
}

@media (max-width: 992px) {
  .section-header {
    padding: 0.4375rem 0.6875rem;
    margin: 0.3125rem 0.3125rem 0.0625rem;
  }
  
  .section-icon {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.5rem;
  }
  
  .section-icon i {
    font-size: 0.625rem;
  }
  
  .section-title {
    font-size: 0.5625rem;
  }
}

/* Efecto liquid glass adicional para el fondo */
.navbar-collapse::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, 
    transparent, 
    rgba(255, 255, 255, 0.4) 20%, 
    rgba(255, 255, 255, 0.6) 50%, 
    rgba(255, 255, 255, 0.4) 80%, 
    transparent
  );
  border-radius: 1rem 1rem 0 0;
  z-index: 1;
}

/* Estados específicos para modo oscuro - ya manejados por las variables CSS */
body.dark-mode-active .navbar-collapse {
  /* Las variables CSS ya manejan automáticamente el modo oscuro */
}

body.dark-mode-active .navbar-nav {
  /* Las variables CSS ya manejan automáticamente el modo oscuro */
}

body.dark-mode-active .section-header {
  backdrop-filter: blur(20px);
  border-color: var(--dm-border-primary);
}

body.dark-mode-active .section-icon {
  box-shadow: 0 4px 12px var(--dm-shadow-accent);
}

body.dark-mode-active .spinner-border {
  border-color: var(--dm-accent-primary) transparent var(--dm-accent-primary) transparent;
}

/* Mejoras para modo claro - asegurar visibilidad */
body:not(.dark-mode-active) .navbar-collapse {
  background: rgba(255, 255, 255, 0.4) !important;
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
}

body:not(.dark-mode-active) .navbar-nav {
  background: rgba(255, 255, 255, 0.3) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
}

body:not(.dark-mode-active) .section-header {
  background: rgba(255, 255, 255, 0.3) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 
    0 1px 0 0 rgba(255, 255, 255, 0.6) inset,
    0 0 0 1px rgba(255, 255, 255, 0.25) inset,
    0 4px 8px rgba(0, 0, 0, 0.15),
    0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

body:not(.dark-mode-active) .section-header:hover {
  background: rgba(255, 255, 255, 0.45) !important;
  border: 1px solid rgba(255, 255, 255, 0.7) !important;
  box-shadow: 
    0 1px 0 0 rgba(255, 255, 255, 0.6) inset,
    0 0 0 1px rgba(255, 255, 255, 0.25) inset,
    0 8px 16px rgba(0, 0, 0, 0.18),
    0 4px 8px rgba(0, 0, 0, 0.12) !important;
}

/* Asegurar visibilidad del texto en modo claro */
body:not(.dark-mode-active) .section-title {
  color: rgba(55, 65, 81, 0.8) !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

body:not(.dark-mode-active) .section-header:hover .section-title {
  color: rgba(23, 173, 55, 0.9) !important;
}

@media (max-width: 768px) {
  .section-header {
    padding: 0.375rem 0.625rem;
    margin: 0.25rem 0.25rem 0.0625rem;
  }
  
  .section-icon {
    width: 1.125rem;
    height: 1.125rem;
    margin-right: 0.4375rem;
  }
  
  .section-icon i {
    font-size: 0.5625rem;
  }
  
  .section-title {
    font-size: 0.5rem;
  }
}

/* Asegurar que el contenedor permita sticky positioning */
.navbar-collapse {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: 100vh !important;
}

/* Asegurar que el navbar-nav permita sticky positioning */
.navbar-nav {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  flex: 1 !important;
}
</style>
